import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Announcement, CreateAnnouncement } from '../models/announcement';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private announcementsUrl = `${environment.apiUrl}/announcements/`;

  constructor(private http: HttpClient) { }

  listAnnouncements(page?: number): Observable<{ count: number; results: Announcement[] }> {
    let params = new HttpParams();
    if (page) {
      params = params.append('page', page.toString());
    }
    return this.http.get<{ count: number; results: Announcement[] }>(this.announcementsUrl, { params });
  }

  createAnnouncement(payload: CreateAnnouncement): Observable<Announcement> {
    return this.http.post<Announcement>(this.announcementsUrl, payload);
  }

  deactivateAnnouncement(id: number): Observable<void> {
    const url = `${this.announcementsUrl}${id}/`;
    return this.http.delete<void>(url);
  }
}
